import { useAuth } from '@efacity/react-next-sc';
import React, { useMemo } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { OrgIdParamType } from '@efacity/frontend-next-shared/utils';
import {
  NavigationItemReact,
  NavigationItem,
  ContentWithLeftNavigation
} from '@efacity/frontend-next-shared/left-navigation';

interface MainLayoutProps {
  shouldRedirectOnLogout?: boolean;
  children?: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { orgId: paramsOrgId } = useParams<OrgIdParamType>();
  const { authState } = useAuth();
  const { extraAuthInfo, workingAccessId } = authState;

  const orgId = useMemo(() => {
    if (paramsOrgId || workingAccessId) {
      return paramsOrgId || workingAccessId;
    } else if (extraAuthInfo?.startRegistrationURL) {
      const regUrl = extraAuthInfo.startRegistrationURL;
      const regMatch = regUrl.match(/^\/(org|center|school)\/(.{24})$/);

      if (regMatch) {
        return regMatch[2];
      }
      return null;
    }
    return null;
  }, [paramsOrgId, workingAccessId, extraAuthInfo]);

  const renderNavigationItem = (navigationItem: NavigationItem, key: string) => {
    return <NavigationItemReact key={key} navigationItem={navigationItem} />;
  };

  return (
    <ContentWithLeftNavigation orgId={orgId} authState={authState} renderNavigationItem={renderNavigationItem}>
      <Outlet />
      {children}
    </ContentWithLeftNavigation>
  );
};
export default MainLayout;
